import RatingBox from "components/RatingBox"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { tourDetailSelector, authSelector } from "redux/selector"
import { RattingWrapper } from "./styled"
import { rattingCommentActions } from "redux/slice/rattingCommentSlice"
import { rattingCommentSelector } from "redux/selector"
import RattingComment from "../FormRattingComment"
import RattingList from "../RattingList"
import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import Pagination from '@mui/material/Pagination';
import useParams from "hooks/useParams"
import { role } from "common/general"

const Ratting = () => {
    const tourDetailState = useSelector(tourDetailSelector)
    const rattingState = useSelector(rattingCommentSelector)
    const tourId = tourDetailState.tourData.tour_id
    const dispatch = useDispatch()
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const qSort = query.get("sort")
    const qStar = query.get("star")
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const authState = useSelector(authSelector)
    const navigate = useNavigate()
    const pathname = location.pathname;
    const { setParams } = useParams()

    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        setParams({ page: pageNumber })
    }


    const isRatting = useMemo(() => {
        if (rattingState.dataAccount.length > 0 && authState.isLoggedIn) {
            let check = false
            rattingState.dataAccount.forEach(item => {
                if (item.account_id === authState.currentUser?.user?.account_id) {
                    check = true
                }
            })
            return check
        }

        return false
    }, [authState.currentUser?.user?.account_id, authState.isLoggedIn, rattingState.dataAccount])


    const callBack = () => {
        dispatch(rattingCommentActions.getRattingPoint({ id: tourId }))
        dispatch(rattingCommentActions.getRattingData({ id: tourId, currentPage, sort: qSort ? qSort : "DESC", star: (qStar && qStar !== "all") ? parseInt(qStar) : "all" }))
    }
    useEffect(() => {
        if (tourId) {
            dispatch(rattingCommentActions.getRattingPoint({ id: tourId }))

        }
    }, [dispatch, tourId])

    useEffect(() => {
        if (tourId) {
            dispatch(rattingCommentActions.getRattingData({ id: tourId, currentPage, sort: qSort ? qSort : "DESC", star: (qStar && qStar !== "all") ? parseInt(qStar) : "all" }))

        }
    }, [currentPage, dispatch, qSort, qStar, tourId])

    return (
        <RattingWrapper>
            {
                rattingState.pointData.length > 0 &&
                <RatingBox data={rattingState.pointData} pointStar={rattingState.point} />
            }
            {
                authState.role === role.CUSTOMER &&
                <>
                    <div className='text-black bold s-18 mb-20 bb-grey2-1 pb-5'>Đánh giá tour:</div>
                    {
                        authState.isLoggedIn && !isRatting &&
                        <RattingComment callBack={callBack} tourId={tourId} />
                    }
                    {
                        authState.isLoggedIn && isRatting &&
                        <div className="box_is_rated b-grey-1 mt-20 b-radius-4 flex-center">
                            <span className="text-red medium">
                                Bạn đã đánh giá tour này
                            </span>
                        </div>
                    }
                    {
                        !authState.isLoggedIn &&
                        <div className="box_is_rated b-grey-1 mt-20 b-radius-4 flex-center clickable"
                            onClick={() => navigate("/login", { state: { pathname } })}
                        >
                            <span className="text-red medium">
                                Đăng nhập để đánh giá tour
                            </span>
                        </div>
                    }
                </>
            }

            <div className="flex-space mt-40">
                <div>
                    <button className={`btn_star clickable b-grey-1 mr-5 b-radius-8 ${(!qStar || qStar === "all" ? "bg-red-2 text-white" : "")}`} onClick={() => setParams({ star: "all" })}>Tất cả</button>
                    <button className={`btn_star clickable b-grey-1 mr-5 b-radius-8 ${(qStar && qStar === "5" ? "bg-red-2 text-white" : "")}`} onClick={() => setParams({ star: 5 })}>5 sao</button>
                    <button className={`btn_star clickable b-grey-1 mr-5 b-radius-8 ${(qStar && qStar === "4" ? "bg-red-2 text-white" : "")}`} onClick={() => setParams({ star: 4 })}>4 sao</button>
                    <button className={`btn_star clickable b-grey-1 mr-5 b-radius-8 ${(qStar && qStar === "3" ? "bg-red-2 text-white" : "")}`} onClick={() => setParams({ star: 3 })}>3 sao</button>
                    <button className={`btn_star clickable b-grey-1 mr-5 b-radius-8 ${(qStar && qStar === "2" ? "bg-red-2 text-white" : "")}`} onClick={() => setParams({ star: 2 })}>2 sao</button>
                    <button className={`btn_star clickable b-grey-1 mr-5 b-radius-8 ${(qStar && qStar === "1" ? "bg-red-2 text-white" : "")}`} onClick={() => setParams({ star: 1 })}>1 sao</button>
                </div>
                <select className="btn_filter px-5" value={qSort ? qSort : "DESC"} onChange={e => setParams({ sort: e.target.value })}>
                    <option value="DESC">Đánh giá mới nhất</option>
                    <option value="ASC">Đánh giá cũ nhất</option>
                </select>
            </div>
            <div className="mt-30">
                <RattingList callBack={callBack} />
            </div>
            {
                rattingState.totalPage > 1 &&
                <div className="flex-center mt-30">
                    <Pagination color="primary" count={rattingState.totalPage} variant="outlined" shape="rounded"
                        onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                        page={currentPage}
                    />
                </div>
            }
        </RattingWrapper>
    )
}

export default Ratting